import React from "react";

import { DonutChart } from "../charts/DonutChart";
import { ChartLayout, layoutHeight, layoutWidth } from "../charts/chartTheme";

interface EsgCategoryProps {
    data: any;
    showHeader: boolean;
    showLegend?: boolean;
    style?: React.CSSProperties | undefined;
    layout?: ChartLayout;
}

export const EsgCategory = ({ data, showHeader, layout, showLegend, style }: EsgCategoryProps): React.ReactElement => {
    const rows = Array.isArray(data) ? data : [];
    const slices = rows.map((row) => ({ label: String(row.sustainabilityClass), value: Number(row.value) }));
    const show = typeof showLegend === "boolean" ? showLegend : layout?.showlegend;

    return (
        <React.Fragment>
            {showHeader ? <h3>Hållbarhet</h3> : null}
            <DonutChart
                slices={slices}
                colors={layout?.colorway ?? ["#2ca02c", "#1F5F32", "#2ca02c", "#C8E4C9", "#bdbdbd"]}
                hole={0.4}
                showLegend={show}
                labelMode="label+percent"
                ariaLabel="Hållbarhet"
                height={layoutHeight(layout, 320)}
                width={layoutWidth(layout)}
                style={style}
            />
        </React.Fragment>
    );
};
